import { UseQueryOptions } from '@tanstack/react-query';
import { CuredApiPaths, SortDirection } from 'models/enums';
import useQuery from '../useQuery';
import QueryKeys from './keys';
import type { AccessCentreRolesApiResponse } from 'domains/accessCentre/types';

const DEFAULT_LIMIT = 10;
const DEFAULT_OFFSET = 0;

type UseGetRolesListParams = {
    limit?: number;
    offset?: number;
    searchTerm?: string;
    sortColumn?: string;
    sortDirection?: SortDirection;
    reactQueryOptions?: UseQueryOptions<AccessCentreRolesApiResponse, Error>;
};

/** GET /roles — list all roles */
const useGetRolesList = ({
    limit = DEFAULT_LIMIT,
    offset = DEFAULT_OFFSET,
    searchTerm,
    sortColumn,
    sortDirection,
    reactQueryOptions,
}: UseGetRolesListParams = {}) => {
    const queryKey = QueryKeys.ACCESS_CENTRE_ROLES(limit, offset, searchTerm, sortColumn, sortDirection);
    const params: {
        limit: number;
        offset: number;
        searchTerm?: string;
        sort?: string;
    } = { limit, offset };
    if (searchTerm?.trim()) {
        params.searchTerm = searchTerm.trim();
    }
    if (sortColumn && sortDirection) {
        params.sort = `${sortColumn}:${sortDirection}`;
    }
    const axiosOptions = { params };

    return useQuery<AccessCentreRolesApiResponse>(
        queryKey,
        CuredApiPaths.ACCESS_CENTRE_ROLES,
        reactQueryOptions,
        axiosOptions
    );
};

export default useGetRolesList;
